export default __webpack_public_path__ + "static/media/bankman.56dd93c2.png";